<!-- #valueTemplate
    Dalla documentazione: https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates/#toc-value-template

    Value Template
    To customize the content of the element which holds the selected text, use the value template. To define a value template, nest an <ng-template> tag with a kendoDropDownListValueTemplate directive inside a <kendo-dropdownlist> tag.
-->
<ng-template #valueTemplate
	let-dataItem>
	@if (dataItem) {
		<div class="value-row">
			<div class="value-label">
				<span container="body"
					tooltipClass="nr-tooltip"
					[placement]="tooltipPlacement"
					[ngbTooltip]="dataItem.label"
					[class.inactive]="dataItem.inactive"
					[class.deleted]="dataItem.deleted">{{dataItem.label}}
				</span>
			</div>

			@if (dataItem.qualifier) {
				<span class="value-qualifier">
					@if (qualifierTranslatePrefix) {
					{{ (qualifierTranslatePrefix+dataItem.qualifier)|translate }}
					}
					@else {
					{{ dataItem.qualifier }}
					}
				</span>
			}

			@if (showIdOnItem) {
				<span class="value-id">{{ dataItem.id }}</span>
			}
		</div>
	}
</ng-template>

<!-- #itemTemplate
    Dalla documentazione: https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates/#toc-item-template

    Item Template
    To customize the content of the suggestion list items, use the item template. To define an item template, nest an <ng-template> tag with the kendoDropDownListItemTemplate directive inside a <kendo-dropdownlist> tag.
-->
<ng-template #itemTemplate
	let-dataItem>
	@if (dataItem) {
		<div class="item-row">
			<div class="item-label">
				<span
					[class.inactive]="dataItem.inactive"
					[class.deleted]="dataItem.deleted">
					{{dataItem.label}}
				</span>

				@if (popOverData) {
					<span class="item-popOverTrigger">
						<i class="fas fa-info-circle"
							container="body"
							tooltipClass="nr-tooltip"
							[placement]="tooltipPlacement"
							[ngbTooltip]="dataItem.label"></i>
					</span>
				}
			</div>

			@if (dataItem.qualifier) {
				<span class="item-qualifier">
					@if (qualifierTranslatePrefix) {
						{{ (qualifierTranslatePrefix+dataItem.qualifier)|translate }}
					}
					@else {
						{{ dataItem.qualifier }}
					}
				</span>
			}

			@if (showIdOnOptions) {
				<span class="item-id">{{ dataItem.id }}</span>
			}
		</div>
	}
</ng-template>

<div class="dropdown-container"
	[formGroup]="this.dropDownForm">
	<kendo-dropdownlist [data]="itemsSource.items$ | async"
		class="position-abs"
		(focus)="onListFocus()"
		[style.visibility]="showList && value != null ? 'visible' : 'hidden'"
		[style.display]="showList && value != null ? 'flex' : 'none'"
		[value]="value"
		[valueField]="this.valueField"
		[textField]="this.textField"
		[valuePrimitive]="false"
		[size]="this.size"
		[disabled]="disabled">
		<ng-template kendoDropDownListValueTemplate
			let-dataItem>
			<ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: dataItem }"></ng-container>
		</ng-template>

		<ng-template kendoDropDownListItemTemplate
			let-dataItem>
			<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: dataItem }"></ng-container>
		</ng-template>
	</kendo-dropdownlist>

	<kendo-combobox [style.visibility]="!showList || value == null ? 'visible' : 'hidden'"
		class="position-abs"
		(blur)="onComboBlur()"
		[data]="itemsSource.items$ | async"
		[loading]="itemsSource.searching$ | async"
		[value]="value"
		(ngModelChange)="setValue($event)"
		[valueField]="this.valueField"
		[textField]="this.textField"
		[valuePrimitive]="false"
		[filterable]="true"
		[size]="this.size"
		(filterChange)="onFilterChanged($event)"
		(valueChange)="onSelectionChanged($event)"
		[placeholder]="placeholder"
		formControlName="comboboxControl">

		<ng-template kendoComboBoxNoDataTemplate>
			@if (filterText == null || filterText == '') {
				<span>{{ 'NR-DROPDOWN.TYPE-TO-SEARCH' | translate }}</span>
			} @else {
				<span>{{ 'NR-DROPDOWN.NOT-FOUND' | translate }}</span>
			}
		</ng-template>

		<ng-template kendoComboBoxItemTemplate
			let-dataItem>
			<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: dataItem }"></ng-container>
		</ng-template>

	</kendo-combobox>
</div>

<!-- **
 * LINKOLOGY
 * ----------------------------------------------------------------------------
 *	https://www.telerik.com/kendo-angular-ui/components/dropdowns/
 * -->
